import { useState } from 'react';
import type { GiaBan } from '@/types/schemas';

export function useUpdatePriceDialog(_onSubmit?: (data: GiaBan) => void) {
  const [updatePriceDialogOpen, setUpdatePriceDialogOpen] = useState(false);
  const [priceMode, setPriceMode] = useState<'add' | 'edit' | 'view'>('add');
  const [selectedPriceData, setSelectedPriceData] = useState<GiaBan | null>(null);

  const openAddDialog = () => {
    setPriceMode('add');
    setSelectedPriceData(null);
    setUpdatePriceDialogOpen(true);
  };

  const openEditDialog = (row: GiaBan) => {
    setPriceMode('edit');
    setSelectedPriceData(row);
    setUpdatePriceDialogOpen(true);
  };

  const closeDialog = () => {
    setUpdatePriceDialogOpen(false);
    setSelectedPriceData(null);
  };

  return {
    updatePriceDialogOpen,
    priceMode,
    selectedPriceData,
    setSelectedPriceData,
    openAddDialog,
    openEditDialog,
    closeDialog
  };
}
